import React from "react"

import { DatePicker, DatePickerProps } from "@mui/x-date-pickers"

const CustomDatePicker = React.forwardRef<HTMLDivElement, DatePickerProps>(
  (props, ref) => {
  return <DatePicker {...props} ref={ref} />
})

CustomDatePicker.displayName = "CustomDatePicker"

export default CustomDatePicker
